/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from 'react'
import ReactDataGrid from '@inovua/reactdatagrid-enterprise'
import '@inovua/reactdatagrid-enterprise/index.css'
import { useTranslation } from 'react-i18next'
import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
import { isArray, isFinite } from 'lodash'
import moment from 'moment'
import { REACTDATAGRID_LICENSE } from '../../utils/constants'
import i18n from '../../i18n'
import {
  flat,
  handleColor,
  isValidISO8601,
  onErrorTxt,
} from '../../utils/CommonMethods'
import dateFormat from '../../utils/dateFormat'

export function CPIDataGrid(props) {
  const { t } = useTranslation()
  const [dataSource, setDataSource] = useState([])
  const [header, setHeader] = useState([])
  const [names, setNames] = useState([])

  const [exportshow, setExportshow] = useState(false)
  const isGrouppingMode = !!(
    props.defaultGroupBy && props.defaultGroupBy.length > 0
  )

  const i18nGB = { ...ReactDataGrid.defaultProps.i18n }
  const i18nDifferentGB = {
    ...ReactDataGrid.defaultProps.i18n,
    pageText: t('datagrid.pageText'),
    ofText: t('datagrid.ofText'),
    perPageText: t('datagrid.perPageText'),
    showingText: t('datagrid.showingText'),
    clearAll: t('datagrid.clearAll'),
    clear: t('datagrid.clear'),
    showFilteringRow: t('datagrid.showFilteringRow'),
    hideFilteringRow: t('datagrid.hideFilteringRow'),
    enable: t('datagrid.enable'),
    disable: t('datagrid.disable'),
    sortAsc: t('datagrid.sortAsc'),
    sortDesc: t('datagrid.sortDesc'),
    unsort: t('datagrid.unsort'),
    group: t('datagrid.group'),
    ungroup: t('datagrid.ungroup'),
    lockStart: t('datagrid.lockStart'),
    lockEnd: t('datagrid.lockEnd'),
    unlock: t('datagrid.unlock'),
    columns: t('datagrid.columns'),
    autoresizeThisColumn: t('datagrid.autoresizeThisColumn'),
    autoresizeAllColumns: t('datagrid.autoresizeAllColumns'),
    autoSizeToFit: t('datagrid.autoSizeToFit'),
    contains: t('datagrid.contains'),
    startsWith: t('datagrid.startsWith'),
    endsWith: t('datagrid.endsWith'),
    notContains: t('datagrid.notContains'),
    inlist: t('datagrid.inlist'),
    notinlist: t('datagrid.notinlist'),
    neq: t('datagrid.neq'),
    inrange: t('datagrid.inrange'),
    notinrange: t('datagrid.notinrange'),
    eq: t('datagrid.eq'),
    notEmpty: t('datagrid.notEmpty'),
    empty: t('datagrid.empty'),
    lt: t('datagrid.lt'),
    lte: t('datagrid.lte'),
    gt: t('datagrid.gt'),
    gte: t('datagrid.gte'),
    before: t('datagrid.before'),
    beforeOrOn: t('datagrid.beforeOrOn'),
    afterOrOn: t('datagrid.afterOrOn'),
    after: t('datagrid.after'),
    start: t('datagrid.start'),
    end: t('datagrid.end'),
    dragHeaderToGroup: t('datagrid.dragHeaderToGroup'),
    noRecords: t('datagrid.noRecords'),
    calendartodayButtonText: t('datagrid.calendartodayButtonText'),
    calendarclearButtonText: t('datagrid.calendarclearButtonText'),
    calendarokButtonText: t('datagrid.calendarokButtonText'),
    calendarcancelButtonText: t('datagrid.calendarcancelButtonText'),
  }
  function getLetterByPosition(position) {
    // Validation d'entrée
    if (typeof position !== 'number' || !isFinite(position)) {
      console.warn(
        `Position invalide: ${position}, utilisation de 1 par défaut`
      )
      position = 1
    }

    if (position < 1) {
      console.warn(`Position trop petite: ${position}, utilisation de 1`)
      position = 1
    }

    if (position > 16384) {
      console.warn(`Position trop grande: ${position}, utilisation de 16384`)
      position = 16384
    }

    let result = ''
    let pos = position

    while (pos > 0) {
      pos--
      result = String.fromCharCode(65 + (pos % 26)) + result
      pos = Math.floor(pos / 26)
    }

    return result
  }

  function isValidDate(dateString) {
    if (dateString && dateString != '0000-00-00T00:00:00.000') {
      return (
        moment(dateString, 'DD-MM-YYYY', true).isValid() ||
        moment(dateString, 'YYYY-MM-DD', true).isValid() ||
        moment(dateString, 'YYYY-M-DD', true).isValid() ||
        moment(dateString, 'YYYY-MM-D', true).isValid() ||
        moment(dateString, 'YYYY-M-D', true).isValid() ||
        moment(dateString, 'DD/MM/YYYY', true).isValid() ||
        moment(dateString, 'DD/M/YYYY', true).isValid() ||
        moment(dateString, 'D/M/YYYY', true).isValid() ||
        isValidISO8601(dateString)
      )
    }
    return false
  }

  /**
   * Ajoute la ligne d'en-tête avec style
   * @param {Worksheet} worksheet - Feuille de calcul
   * @param {Array} header - En-têtes des colonnes
   */
  const addHeaderRow = (worksheet, header) => {
    const floorHeader = header.map((head) => {
      const isNotString = head && typeof head !== 'string'
      if (!isNotString) return head
      return ''
    })
    const headerRow = worksheet.addRow(floorHeader)
    headerRow.height = 35

    // Application des styles à chaque cellule d'en-tête
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF7D7D' },
        bgColor: { argb: 'FF000000' },
      }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
      cell.font = {
        bold: true,
        size: 12,
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
    })
  }

  /**
   * Configure l'en-tête et le titre du document
   * @param {Worksheet} worksheet - Feuille de calcul
   * @param {Array} header - En-têtes des colonnes
   * @param {string} title - Titre du document
   */
  const setupHeaderAndTitle = (worksheet, header, title) => {
    const lastCol = getLetterByPosition(header.length)
    const preLast = getLetterByPosition(header.length - 1)
    const titleEndCol = getLetterByPosition(header.length - 2)
    if (header.length > 2) {
      const formattedDate = moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
      const dateRange = `${preLast}1:${lastCol}1`

      worksheet.getCell(dateRange).value = formattedDate
      worksheet.mergeCells(dateRange)

      // Style de la cellule de date
      worksheet.getCell(`${lastCol}1`).font = {
        bold: true,
        size: 12,
      }
    }

    // Ajout et style du titre
    const titleRange = `A1:${titleEndCol}1`
    worksheet.getCell(titleRange).value = title
    worksheet.mergeCells(titleRange)

    // Hauteur de la première ligne et alignement
    worksheet.getRow(1).height = 40
    worksheet.getRow(1).alignment = {
      horizontal: 'center',
      vertical: 'middle',
    }

    // Police en gras pour la première ligne
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = {
        bold: true,
        size: 16,
      }
    })

    // Ajout des en-têtes de colonnes
    addHeaderRow(worksheet, header)
  }

  /**
   * Ajoute les données à la feuille de calcul par lots
   * @param {Worksheet} worksheet - Feuille de calcul
   * @param {Array} dataSource - Source de données
   */
  const addDataToWorksheet = (worksheet, dataSource) => {
    const batchSize = 100

    for (
      let rowIndex = 0;
      rowIndex < dataSource.length;
      rowIndex += batchSize
    ) {
      const batchData = dataSource.slice(rowIndex, rowIndex + batchSize)

      batchData.forEach((rowData) => {
        worksheet.addRow(rowData).height = 25
      })
    }
  }

  /**
   * Applique des bordures à toutes les cellules
   * @param {Worksheet} worksheet - Feuille de calcul
   */
  const applyBorders = (worksheet) => {
    const borderStyles = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }

    worksheet.eachRow({ includeEmpty: false }, (row) => {
      row.eachCell({ includeEmpty: false }, (cell) => {
        cell.border = borderStyles
      })
    })
  }

  /**
   * Optimise les largeurs de colonnes en fonction du contenu
   * @param {Worksheet} worksheet - Feuille de calcul
   */
  const optimizeColumnWidths = (worksheet) => {
    worksheet.columns.forEach((column) => {
      let maxLength = 0

      column.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
        if (rowNumber > 1) {
          // Ignorer la ligne d'en-tête pour le calcul
          const cellText = cell.value ? cell.value.toString().trim() : ''
          maxLength = Math.max(
            maxLength,
            cellText.length + 5 + (props.decimalNumberFormat || 2)
          )
        }
      })

      column.width = Math.max(10, maxLength)
    })
  }

  function dateToExcelSerial(annee, mois, jour) {
    const date = new Date(Date.UTC(annee, mois - 1, jour))
    const epoch = new Date(Date.UTC(1899, 11, 30)) // 30 déc 1899 (base Excel)
    const days = (date - epoch) / (24 * 60 * 60 * 1000)
    return days
  }

  function buildNumberFormat(decimale = 2) {
    const decimalPart = '0'.repeat(decimale)
    return `#,##0.${decimalPart}`
  }

  /**
   * Formate les valeurs des cellules (nombres, dates, etc.)
   * @param {Worksheet} worksheet - Feuille de calcul
   */
  const formatCellValues = (worksheet) => {
    const numberFormat = buildNumberFormat(props.decimalNumberFormat || 2)

    const dateFormatWithTime =
      i18n.language === 'en'
        ? 'mm/dd/yyyy HH:mm:ss AM/PM'
        : 'dd/mm/yyyy HH:mm:ss'

    const simpleDateFormat =
      i18n.language === 'en' ? 'mm/dd/yyyy' : 'dd/mm/yyyy'
    worksheet.eachRow({ includeEmpty: false }, (row) => {
      row.eachCell((cell) => {
        try {
          if (
            cell.value === undefined ||
            cell.value === 'undefined' ||
            cell.value === '0000-00-00T00:00:00.000'
          ) {
            cell.value = ''
            return
          }

          if (typeof cell.value === 'string') {
            const trimmedValue = cell.value.trim()

            // Cas spécial: date invalide
            if (trimmedValue === '0000-00-00') {
              cell.value = ''
              return
            }

            // Conversion de chaînes numériques avec espaces
            if (trimmedValue.includes(' ')) {
              const parsedNumber = Number(
                trimmedValue.replace(/\s/g, '').replace(/,/g, '.')
              )

              if (!Number.isNaN(parsedNumber)) {
                cell.value = parsedNumber
                cell.numFmt = numberFormat
              }
            }

            // Traitement des dates
            if (isValidDate(trimmedValue)) {
              const isNullDate =
                trimmedValue?.split('T')?.[1] === '00:00:00.000'
              const hasTime = isValidISO8601(trimmedValue) && !isNullDate

              const validDate = hasTime
                ? dateFormat.dateAndHour(trimmedValue)
                : dateFormat.simpleDate(trimmedValue)
              const [datePart, timePart] = validDate.split('  ')
              const parts =
                i18n.language === 'en'
                  ? datePart.trim().split('-').map(Number)
                  : datePart.trim().split('/').map(Number)
              const [jour, mois, annee] =
                i18n.language === 'en' ? [parts[1], parts[0], parts[2]] : parts

              if (timePart) {
                const timeStr = timePart.trim()
                const isPM = timeStr.includes('PM')
                const isAM = timeStr.includes('AM')
                const cleanTime = timeStr.replace(/\s?(AM|PM)/i, '')

                const [heures = 0, minutes = 0, secondes = 0] = cleanTime
                  .split(':')
                  .map(Number)

                let heures24 = heures

                if (isAM && heures === 12) {
                  heures24 = 0
                } else if (isPM && heures !== 12) {
                  heures24 = heures + 12
                }

                cell.value = new Date(
                  Date.UTC(annee, mois - 1, jour, heures24, minutes, secondes)
                )
              } else {
                cell.value = dateToExcelSerial(annee, mois, jour)
              }

              cell.numFmt = hasTime ? dateFormatWithTime : simpleDateFormat
            }
          }
          // Formatage des nombres purs
          else if (typeof cell.value === 'number' && !cell.numFmt) {
            cell.numFmt = numberFormat
          }
        } catch (error) {
          console.error(
            'Erreur lors du traitement de la cellule:',
            cell.value,
            error
          )
        }
      })
    })
  }

  /**
   * Génère et télécharge le fichier Excel
   * @param {Workbook} workbook - Classeur Excel
   * @param {string} title - Titre du document (utilisé pour le nom de fichier)
   * @returns {Promise<void>}
   */
  const generateAndDownloadExcel = async (workbook, title) => {
    const buffer = await workbook.xlsx.writeBuffer()

    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const filename = `${(title && title.substring(0, 75)) || 'doc'}.xlsx`
    fs.saveAs(blob, filename)
  }

  /**
   * Exporte les données dans un fichier Excel avec formatage
   * @returns {Promise<void>}
   *
   *
   */

  const sanitizeSheetName = (name) => {
    const cleaned = name.replace(/[*?:\\/[\]]/g, '-')
    // Supprimer les caractères invisibles ou spéciaux Unicode
    const normalized = cleaned.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    return normalized
  }

  const exportFile = async () => {
    try {
      // Création du workbook et de la feuille
      const title = props.title || 'Titre tableau'
      const workbook = new Workbook()
      const safeSheetName = sanitizeSheetName(title || 'classeur1')
      const worksheet = workbook.addWorksheet(safeSheetName)

      // Configuration de l'en-tête
      setupHeaderAndTitle(worksheet, header, title)

      // Ajout des données par lots
      addDataToWorksheet(worksheet, dataSource)

      // Application des styles et formatage
      applyBorders(worksheet)
      optimizeColumnWidths(worksheet)
      formatCellValues(worksheet)

      // Export du fichier
      await generateAndDownloadExcel(workbook, title)
    } catch (error) {
      console.error("Erreur lors de l'exportation:", error)
    }
  }

  const sortedTable = (data, key) => {
    const tempObject = {}

    data &&
      data.forEach((item) => {
        const groupingKey = item[key]
        if (!tempObject[groupingKey]) {
          tempObject[groupingKey] = []
        }
        tempObject[groupingKey].push(item)
      })
    return tempObject
  }

  function reorganizeObjectsByOrder(objectsArray, orderArray) {
    const sortedArray = [...objectsArray]

    sortedArray?.sort((a, b) => {
      const indexA = orderArray?.indexOf(a.name)
      const indexB = orderArray?.indexOf(b.name)

      if (indexA === -1) return 1
      if (indexB === -1) return -1

      return indexA - indexB
    })

    return sortedArray
  }

  useEffect(() => {
    const organisedHeaders = reorganizeObjectsByOrder(
      props.columns,
      props.columnOrder
    ).filter(
      (el) =>
        el.name !== 'action' &&
        !(props.excludeColumn || []).includes(el.name) &&
        el.visible !== false
    )

    const headers = isGrouppingMode
      ? [{ name: 'grouped', header: '' }, ...organisedHeaders]
      : organisedHeaders

    const tempHeaders = headers.map((t) => {
      if (!!t.group && !!props.groups && isArray(props.groups)) {
        const findIndex = props.groups.findIndex((e) => e.name === t.group)
        if (findIndex >= 0)
          return `${t.header} ${
            props.groups[findIndex]?.complete || findIndex + 1
          }`
      }
      return t.header
    })
    const tempName = headers.map((t) => t.name)

    setHeader(tempHeaders)
    setNames(tempName)
    setExportshow(props.export)
    return () => {}
  }, [props.columns, props.columnOrder])

  // Function de recuperer les label
  function updateValues(table1, table2) {
    const updatedTable = JSON.parse(JSON.stringify(table1))
    const processObject = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (Array.isArray(obj[key])) {
          obj[key] = obj[key].map((item) => {
            if (typeof item === 'object' && item !== null) {
              return processObject(item)
            }
            return item
          })
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          obj[key] = processObject(obj[key])
        }
        const matchingFilter = table2.find(
          (filter) => filter.key?.toString() === key?.toString()
        )
        if (matchingFilter) {
          const colorResult = handleColor(matchingFilter.value, obj[key])
          if (colorResult && colorResult?.label) {
            obj[key] = colorResult?.label || ''
          } else {
            obj[key] = ''
          }
        }
      })
      return obj
    }
    return updatedTable.map((item) => processObject(item))
  }

  useEffect(() => {
    if (props.dataSource && names.length > 0) {
      const exportedDataSource = props?.customFunctionExported
        ? props?.customFunctionExported(props.dataSource)
        : props.dataSource

      let Datas = reorganizeObjectsByOrder(
        exportedDataSource,
        props.columnOrder
      )

      if (props.wrapedText && props.wrapedText.length > 0) {
        Datas = updateValues(exportedDataSource, props.wrapedText)
      }

      const factoriseArray = props.cbArray
        ? props.cbArray(Datas)
        : props.treeColumn
        ? flat(Datas, 'nodes')?.map((d) =>
            d.e_level
              ? {
                  ...d,
                  [props.treeColumn]: `${'   '.repeat(d.e_level)}${
                    d[props.treeColumn]
                  }`,
                }
              : d
          )
        : Datas

      const grouppingTab = []
      if (isGrouppingMode) {
        const filteredTable = sortedTable(
          factoriseArray,
          props.defaultGroupBy[0]
        )

        for (const key in filteredTable) {
          const currentKey = key
          const currentTab = filteredTable[key]
          const emptyGroupping = currentTab[0]
          const copiedObject = { ...emptyGroupping }

          for (const key in copiedObject) {
            const removedObject = typeof copiedObject[key] !== 'object'
            if (removedObject) {
              copiedObject[key] = ''
            }
          }
          const allObject = [copiedObject, ...currentTab].map((el, index) => {
            if (index === 0) {
              return {
                grouped: currentKey,
                ...el,
              }
            }
            return {
              grouped: '',
              ...el,
            }
          })
          grouppingTab.push(allObject)
        }
      }
      const arrayExported = isGrouppingMode
        ? grouppingTab.flat()
        : factoriseArray

      const tempDataSource =
        arrayExported &&
        arrayExported.map((el) => {
          const tempData = []
          for (const i of names) {
            const d =
              typeof el[i] === 'object'
                ? Array.isArray(el[i])
                  ? el[i]
                      .map((e) =>
                        typeof e === 'object' && !Array.isArray(e) ? e.label : e
                      )
                      .join(',')
                  : el[i] && el[i].label
                : el[i]
            tempData.push(d)
          }
          return tempData
        })

      setDataSource(tempDataSource)
    }

    return () => {}
  }, [props.dataSource, names])

  return (
    <>
      <div
        style={{
          display: props.isExported || exportshow ? 'flex' : 'none',
          position: 'absolute',
          bottom: props.isExported ? props.defaultBottom || -45 : 8,
          right: props.defaultRigth || 15,
          zIndex: 500,
        }}
      >
        <button
          type="button"
          style={{ backgroundColor: 'transparent' }}
          onClick={() => {
            if (dataSource.length === 0) {
              onErrorTxt(t('data_grid.noDataToExport'))
            } else {
              exportFile()
            }
          }}
          onKeyDown={() => {
            if (dataSource.length === 0) {
              onErrorTxt(t('data_grid.noDataToExport'))
            } else {
              exportFile()
            }
          }}
        >
          <img
            // eslint-disable-next-line global-require
            src={require('../../assets/images/excel.png')}
            alt="Export data to Excel"
            style={{
              cursor: 'pointer',
              height: 20,
              width: 20,
            }}
          />
        </button>
      </div>

      <ReactDataGrid
        className="selectable-grid"
        licenseKey={REACTDATAGRID_LICENSE}
        rowHeight={30}
        style={{ height: props.heightDataGrid || '100%' }}
        pagination="local"
        defaultLimit={500}
        emptyText={t('NoData')}
        showCellBorders={false}
        showZebraRows
        showHoverRows
        pageSizes={[25, 50, 100, 250, 500, 1000, 2500, 5000]}
        i18n={i18n.language === 'en' ? i18nGB : i18nDifferentGB}
        summaryReducer={props.summaryReducer}
        footerRows={props.footerRows}
        disableGroupByToolbar
        {...props}
      />
    </>
  )
}
